import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-druid",
  "use": "icon-druid-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-druid\"><defs><style></style></defs><path d=\"M832 128H192a64.19 64.19 0 00-64 64v640a64.19 64.19 0 0064 64h640a64.19 64.19 0 0064-64V192a64.19 64.19 0 00-64-64zm0 703.89l-.11.11H192.11l-.11-.11V768h640zM832 544H720L605.6 696.54 442.18 435.07 333.25 544H192v-64h114.75l147.07-147.07L610.4 583.46 688 480h144zm0-288H192v-63.89l.11-.11h639.78l.11.11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol